import styled from 'styled-components';

import InfoIcon from '@mui/icons-material/Info';

export const AccessRowShell = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => theme.spacing(1.5, 2)};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-wrap: wrap;
  }
`;

export const AccessRowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  flex: 1;
  min-width: 0;
`;

export const AccessRowTitle = styled.span`
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  color: ${({ theme }) => theme.palette.text.primary};
  overflow-wrap: anywhere;
`;

export const AccessRowTitleLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const AccessRowMeta = styled.span`
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  line-height: 150%;
  color: ${({ theme }) => theme.palette.text.secondary};
  overflow-wrap: anywhere;
`;

export const AccessRowActions = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing(0.5)};

  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-basis: 100%;
  }
`;

export const Plain = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: 150%;
  color: ${({ theme }) => theme.palette.text.primary};

  & + & {
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
`;

export const Muted = styled(Plain)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const RolesBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;

export const RoleList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 8px;
  overflow: hidden;

  & > li:last-child {
    border-bottom: none;
  }
`;

export const RolesFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const RoleInfoIcon = styled(InfoIcon)`
  display: block;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const HelperText = styled.span`
  margin-left: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
`;
